<section class="av-billing-box h-100">
    <div class="av-billing-box__header">
        <mat-icon>workspace_premium</mat-icon>
        <h2>{{ labelKey() | translate }}</h2>
    </div>

    @if (component().unit_amount !== null) {
    <p class="av-billing-note m-0">
        {{ 'app.billing.licences.unit_price' | translate: {
                amount: (component().unit_amount | currency: (component().currency ?? 'EUR') : 'symbol' : '1.2-2')
            } }}
    </p>
    }

    <div class="av-billing-row">
        <span class="av-billing-row__label">{{ 'app.billing.licences.metrics.purchased' | translate }}</span>
        <span class="av-billing-row__value">{{ component().purchased }}</span>
    </div>

    <div class="av-billing-row">
        <span class="av-billing-row__label">{{ 'app.billing.licences.metrics.assigned' | translate }}</span>
        <span class="av-billing-row__value">{{ component().assigned }}</span>
    </div>

    <div class="av-billing-row">
        <span class="av-billing-row__label">{{ 'app.billing.licences.metrics.free' | translate }}</span>
        <span class="av-billing-row__value">{{ component().free }}</span>
    </div>

    <div class="av-billing-row">
        <span class="av-billing-row__label">{{ 'app.billing.licences.metrics.ending' | translate }}</span>
        <span class="av-billing-row__value">{{ component().pending_cancellation }}</span>
    </div>

    <div class="av-billing-box__actions mt-auto pt-2">
        <button mat-flat-button color="primary" (click)="buy.emit(component())">
            {{ 'app.billing.licences.actions.buy' | translate }}
        </button>
        <button mat-stroked-button [disabled]="!isCancellable()"
            [matTooltip]="isCancellable() ? '' : ('app.billing.licences.cancel.none' | translate)"
            (click)="cancel.emit(component())">
            {{ 'app.billing.licences.actions.cancel' | translate }}
        </button>
    </div>
</section>
